import React from 'react';
import {Select} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import options from 'helpers/countOptions';

const ClickCountsFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <Select
      dropdownMatchSelectWidth={false}
      mode="multiple"
      allowClear
      value={query.clickCounts || []}
      onChange={(value) => setQuery({page: 1, clickCounts: value})}>
      {options.map((option) => (
        <Select.Option
          value={option.value}
          key={option.value}
          label={option.text}>
          {option.text}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ClickCountsFilter;
